import React, { Component } from "react";
import axios from "axios";
// import {appConfig} from "./../tools/AppConfig";
import Waiting from "./../../components/waiting/waiting";
import { appConfig } from "../../../../tools/AppConfig";
import Card from "./../../components/card/card";
import InstallmentCard from "../../components/installment_card/InstallmentCard";
import Popup_3d_secure from './../../components/popup_3d_secure/popup_3d_secure';
import DeclinedPayment from './DeclinedPayment';
import SuccessfullPayment from './SuccessfullPayment';
import "./OnlineCard.css";

 

class OnlineCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      card_waiting: false,
      paymet_error: false,
      paymet_error_message: "",
      //3d_secure
      popup_3d_secure: false,
      popup_3d_secure_url: "",
      // result_page
      result_page: false,
      //public
      waiting: true,
      error: false,
      error_head: "",
      error_message: "",
    };
  }
  componentDidMount() {
    window.addEventListener("storage",(e) => {
      if(localStorage.popup_3d_secure){
        localStorage.removeItem("popup_3d_secure");
        this.setState({
            popup_3d_secure: false,
            popup_3d_secure_url: "",
            result_page: true,
        },()=>{
            //this.load_result();
        })
      }
    });
  }
  cardTokenization = (card_data) => {
    this.setState({ card_waiting: true }, () => {
      let url = appConfig.getServerUrl() + '/api/acceptance/tokenization?payment_token=' + this.props.payment_token;
      let config = {
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };
      let data = {   
        'pan': card_data.cardNumber,
        'expiry_month': card_data.expiry_mm,
        'expiry_year': card_data.expiry_yy,
        'cardholder_name': card_data.name
      }
      let jsonData = JSON.stringify(data);
      axios.post(
          url,
          jsonData,
          config
      )
      .then(()=>{
        this.pay(card_data)
      })
      .catch((err)=>{
        this.setState({
          paymet_error: true,
          paymet_error_message: "Payment faild!",
          card_waiting: false,
        });
      });
    });
  }
  pay = (card_data) => {
    this.setState({ card_waiting: true }, 
      async (resp) => {
        let url = appConfig.getServerUrl() + "/api/acceptance/payments/pay";
        let config = {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        };
        let data;
        // Installment Payload
        if(card_data.tenure){
          data = {
            source: {
              identifier: card_data.cardNumber,
              sourceholder_name: card_data.name,
              subtype: "CARD",
              expiry_month: card_data.expiry_mm,
              expiry_year: card_data.expiry_yy,
              cvn: card_data.cvc,
              tenure: card_data.tenure
            },
            payment_token: this.props.payment_token,
            api_source: "IFRAME",
            
          };
        }else{
          // Tokenized Card Payload
          if(card_data.token){
            data = {
              source: {
                subtype: "TOKEN",
                identifier: card_data.token,
                cvn: card_data.cvc,
              },
              payment_token: this.props.payment_token,
              api_source: "IFRAME"
            };
          }else{
            data = {
              source: {
                identifier: card_data.cardNumber,
                sourceholder_name: card_data.name,
                subtype: "CARD",
                expiry_month: card_data.expiry_mm,
                expiry_year: card_data.expiry_yy,
                cvn: card_data.cvc,
              },
              payment_token: this.props.payment_token,
              api_source: "IFRAME"
            }
          };
        }
        let jsonData = JSON.stringify(data);
        axios
          .post(url, jsonData, config)
          .then((resp) => {
            if (resp.data.bypass_step_six) {
              if (resp.data.use_redirection) {
                window.top.location.href = resp.data.redirection_url;
              } else {
                if (resp.data.merchant_response.paymob_redirect_url) {
                  window.location.href = resp.data.merchant_response.paymob_redirect_url;
                } else {
                  this.setState({
                    paymet_error: true,
                    paymet_error_message: resp.data.merchant_response,
                    card_waiting: false,
                  });
                }
              }
            } else {
              if (resp.data.merchant_reponse === undefined) {
                if (resp.status == 422) {
                  if (resp.data.redirection != undefined) {
                    window.top.location.href = resp.data.redirection;
                  } else {
                    this.setState({
                      paymet_error: true,
                      paymet_error_message: resp.data.merchant_response,
                      card_waiting: false,
                    });
                  }
                }
              } else {
                if (resp.data.merchant_reponse.paymob_redirect_url) {
                  window.top.location.href = resp.data.merchant_reponse.paymob_redirect_url;
                } else {
                  this.setState({
                    paymet_error: true,
                    paymet_error_message: resp.data.merchant_response,
                    card_waiting: false,
                  });
                }
              }
            }
          })
          .catch((error) => {
            if(error.response && error.response.data && error.response.data.redirect){
              window.top.location.href = error.response.data.redirect;
            }else{
              if(error.response && error.response.data.message){
                this.setState({
                  paymet_error: true,
                  paymet_error_message: error.response.data.message,
                  card_waiting: false,
                });
              }else if(error.response && Array.isArray(error.response.data) && error.response.data[0]){
                this.setState({
                  paymet_error: true,
                  paymet_error_message: error.response.data[0],
                  card_waiting: false,
                });
              }else{
                this.setState({
                  paymet_error: true,
                  paymet_error_message: "Payment faild!",
                  card_waiting: false,
                });
              }
            }
          });
      }
    )
  }
  card_submit = (card_data) => {
    if(card_data.save_card){
      this.cardTokenization(card_data)
    }else{
      this.pay(card_data)
    }
  }
  handle_3d_secure = (trans_data) => {
    this.setState({popup_3d_secure: true, popup_3d_secure_url: trans_data.redirection_url})
  }
  paymet_error = () => {
    return(
      <>
        <p>{this.state.paymet_error_message}</p>
        <button onClick={()=>{
          this.setState({
            paymet_error: false,
            paymet_error_message: "",
            card_waiting: false
          })
        }} >try again</button>
      </>
    )
  }
  render_result = () => {
    return(
      <div>
        <h1>Result Page</h1>
      </div>
    )
  }
  render() {
    return (
      <div className="online_card_main">
        {this.state.paymet_error ?
          // this.paymet_error()
          <DeclinedPayment paymet_error_message={this.state.paymet_error_message} />
        :
          this.state.result_page ? 
            // this.render_result()
            <SuccessfullPayment />
          :
            this.props.is_installment ?
              <InstallmentCard 
                card_submit={this.card_submit}
                waiting={this.state.card_waiting}
                user_can_save_card={true}
                payment_token={this.props.payment_token}
              />
            :
              <Card
                card_submit={this.card_submit}
                waiting={this.state.card_waiting}
                user_can_save_card={true}
                payment_token={this.props.payment_token}
            />
        }
        {this.state.popup_3d_secure &&
          <Popup_3d_secure url={this.state.popup_3d_secure_url} />
        }
      </div>
    );
  }
}

export default OnlineCard;
